// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__TpHKe","FooterText":"Footer_FooterText__T8bWc"};